import  { useMediaQuery } from  "@mui/material";

const useIsMobile = () => {
  // Check if the viewport width is less than or equal to 1280 pixels
  const isMobile = useMediaQuery(`(max-width:1280px)`); // Adjust 'lg' breakpoint as needed

  return isMobile;
};
export default useIsMobile;